import React from 'react'
import { Container, Dropdown, DropdownHeader, DropdownMenu, Image, Nav, NavDropdown, Navbar } from 'react-bootstrap'
import { Link, useNavigate } from "react-router-dom";

const Header = () => {
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <Link to={'/'}>Home</Link>
            <NavDropdown title="Shop" className='shop'>
                <NavDropdown.Item href="/dupatta">Duppata</NavDropdown.Item>
                <NavDropdown.Item href="/shirtTrouser">
                    Shirt Trouser
                </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Bridals" className='shop'>
                <NavDropdown.Item href="/gharara">Gharara / Sharara</NavDropdown.Item>
            </NavDropdown>
            <Link to={'/lahangas'}>Lahangas</Link>
            <Link to={'/maxi'}>Maxi</Link>
            <Link to={'/saree'}>Saree</Link>
        </div>
    )
}

export default Header